export default "__VITE_ASSET__675eef35__"